var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-link",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default"),(_vm.count > 0)?_c('span',[_vm._v(_vm._s(_vm.count))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }